module.exports = __webpack_public_path__ + "img/icon-right-arrow.5d484924.svg";